import http from './http';

export async function changePassword({ current_password, new_password }) {
  const { data } = await http.post('/auth/change-password', { current_password, new_password });
  return data;
}

export async function authPing() {
  const { data } = await http.post('/auth/ping');
  return data;
}

export async function authLogout() {
  const { data } = await http.post('/auth/logout');
  return data;
}

export async function linkGoogleAccount(id_token) {
  const { data } = await http.post('/auth/google/link', { id_token });
  return data;
}
